import {DefaultMetaTags} from '@common/seo/default-meta-tags';
import {StaticPageTitle} from '@common/seo/static-page-title';
import {Form} from '@common/ui/forms/form';
import {FormTextField} from '@common/ui/forms/input-field/text-field/text-field';
import {Button} from '@common/ui/buttons/button';
import {Trans} from '@common/i18n/trans';
import {useForm} from 'react-hook-form';
import {useRecaptcha} from '@common/recaptcha/use-recaptcha';
import {
  ContactPagePayload,
  useSubmitContactForm,
} from '@common/contact/use-submit-contact-form';
import {
  ArrowRight,
  c,
  Container,
  Reveal,
  SiteFooter,
  SiteHeader,
} from './mrigl-shell';

export function MriglContactPage() {
  const form = useForm<ContactPagePayload>();
  const submitForm = useSubmitContactForm(form);
  const {verify, isVerifying} = useRecaptcha('contact');

  return (
    <div
      className="mrigl-landing min-h-screen"
      style={{background: c.bg, color: c.ink}}
    >
      <DefaultMetaTags />
      <StaticPageTitle>
        <Trans message="Contact us" />
      </StaticPageTitle>
      <SiteHeader />
      <main id="main" className="mrigl-contact-main">
        <section className="mrigl-contact-hero">
          <Container className="grid items-center gap-32 md:grid-cols-[0.9fr_1.1fr] md:gap-48">
            <Reveal>
              <span className="preview-pill mb-24 inline-block">
                Contact <strong>MRIGL</strong>
              </span>
              <h1 className="display preview-hero-title mb-24 text-5xl md:text-7xl">
                Une question avant de créer votre site ?
              </h1>
              <p className="hero-subtitle max-w-560">
                Envoyez-nous votre message. On vous répond simplement, sans
                jargon technique.
              </p>
              <div className="contact-mini-grid mt-34">
                <div>
                  <strong>Support</strong>
                  <span>24/7</span>
                </div>
                <div>
                  <strong>Prix clair</strong>
                  <span>8 TND/mois</span>
                </div>
                <div>
                  <strong>Local</strong>
                  <span>Tunisie</span>
                </div>
              </div>
            </Reveal>

            <Reveal>
              <div className="mrigl-contact-card">
                <h2 className="mb-8 text-2xl font-extrabold">
                  <Trans message="Contact us" />
                </h2>
                <p className="mb-30 text-sm" style={{color: c.inkMuted}}>
                  <Trans message="Please use the form below to send us a message and we'll get back to you as soon as possible." />
                </p>
                <Form
                  form={form}
                  onSubmit={async value => {
                    const isValid = await verify();
                    if (isValid) {
                      submitForm.mutate(value);
                    }
                  }}
                >
                  <FormTextField
                    label={<Trans message="Name" />}
                    name="name"
                    required
                    className="mb-20"
                  />
                  <FormTextField
                    label={<Trans message="Email" />}
                    name="email"
                    required
                    type="email"
                    className="mb-20"
                  />
                  <FormTextField
                    label={<Trans message="Message" />}
                    name="message"
                    required
                    inputElementType="textarea"
                    className="mb-20"
                    rows={8}
                  />
                  <Button
                    type="submit"
                    variant="flat"
                    color="primary"
                    disabled={submitForm.isPending || isVerifying}
                    className="contact-submit-btn"
                  >
                    <Trans message="Send" />
                    <ArrowRight />
                  </Button>
                </Form>
              </div>
            </Reveal>
          </Container>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
